import {
  Box,
  Grid,
  Icon,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  DELETE_TABLE_DATA_ERROR,
  DELETE_TABLE_DATA_SUCCESS,
  FETCH_PERMISSION_TABLE_ERROR,
  FETCH_PERMISSION_TABLE_SUCCESS,
  FETCH_ROLE_PERMISSION_TABLE_ERROR,
  FETCH_ROLE_PERMISSION_TABLE_SUCCESS,
  FETCH_ROLE_TABLE_ERROR,
  FETCH_ROLE_TABLE_SUCCESS,
  INSERT_TABLE_DATA_ERROR,
  INSERT_TABLE_DATA_SUCCESS,
  UPDATE_TABLE_DATA_ERROR,
  UPDATE_TABLE_DATA_SUCCESS,
} from "../../store/types/manageDataTypes";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  API_METHOD_PUT,
  ENTITY_STATUS,
} from "../../config/constants";
import { api_request } from "../../store/actions/commonAction";
import { theme } from "../../config/theme";
import Swal from "sweetalert2";
import { setManageDataReducer } from "../../store/actions/manageDataAction";
import { useDispatch, useSelector } from "react-redux";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import CoreAutoComplete from "../../core/inputs/CoreAutoComplete";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreButton from "../../core/inputs/CoreButton";
import CoreInput from "../../core/inputs/CoreInput";
import CoreTypographyCaption from "../../core/dataDisplay/CoreTypographyCaption";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  maxHeight: 450,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
};

export default function AssignRolesModal({ show, permission, onClose }) {
  const dispatch = useDispatch();

  const roleTable = useSelector((state) => state?.manageData?.roleTable);
  const rolePermissionTable = useSelector(
    (state) => state?.manageData?.rolePermissionTable,
  );

  const deleteTableDataSuccess = useSelector(
    (state) => state?.manageData?.deleteTableDataSuccess,
  );
  const deleteTableDataError = useSelector(
    (state) => state?.manageData?.deleteTableDataError,
  );
  const deleteTableDataMsg = useSelector(
    (state) => state?.manageData?.deleteTableDataMsg,
  );

  const insertTableDataSuccess = useSelector(
    (state) => state?.manageData?.insertTableDataSuccess,
  );
  const insertTableDataError = useSelector(
    (state) => state?.manageData?.insertTableDataError,
  );
  const insertTableDataMsg = useSelector(
    (state) => state?.manageData?.insertTableDataMsg,
  );

  const updateTableDataSuccess = useSelector(
    (state) => state?.manageData?.updateTableDataSuccess,
  );
  const updateTableDataError = useSelector(
    (state) => state?.manageData?.updateTableDataError,
  );
  const updateTableDataMsg = useSelector(
    (state) => state?.manageData?.updateTableDataMsg,
  );

  const [open, setOpen] = useState(false);
  const [roleId, setRoleId] = useState(null);

  useEffect(() => {
    getRoles();
    getRolePermission();
  }, []);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  useEffect(() => {
    if (deleteTableDataSuccess) {
      dispatch(setManageDataReducer({ deleteTableDataSuccess: false }));
      getRolePermission();
    }
    if (deleteTableDataError) {
      dispatch(setManageDataReducer({ deleteTableDataError: false }));
      Swal.fire({
        title: "Oops!",
        text: deleteTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
  }, [deleteTableDataSuccess, deleteTableDataError]);

  useEffect(() => {
    if (insertTableDataSuccess) {
      dispatch(setManageDataReducer({ insertTableDataSuccess: false }));
      getRolePermission();
    }
    if (insertTableDataError) {
      dispatch(setManageDataReducer({ insertTableDataError: false }));
      Swal.fire({
        title: "Oops!",
        text: insertTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
  }, [insertTableDataSuccess, insertTableDataError]);

  useEffect(() => {
    if (updateTableDataSuccess) {
      dispatch(setManageDataReducer({ updateTableDataSuccess: false }));
      getRolePermission();
    }
    if (updateTableDataError) {
      Swal.fire({
        title: "Error",
        text: updateTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
      dispatch(setManageDataReducer({ updateTableDataError: false }));
    }
  }, [updateTableDataSuccess, updateTableDataError]);

  const getRoles = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/data/Roles",
        null,
        null,
        null,
        FETCH_ROLE_TABLE_SUCCESS,
        FETCH_ROLE_TABLE_ERROR,
        true,
        false,
        true,
      ),
    );
  };
  const getRolePermission = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/data/RolePermissions",
        null,
        null,
        null,
        FETCH_ROLE_PERMISSION_TABLE_SUCCESS,
        FETCH_ROLE_PERMISSION_TABLE_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const onDelete = (id) => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/data/RolePermissions/delete",
        { tableIds: [id] },
        null,
        null,
        DELETE_TABLE_DATA_SUCCESS,
        DELETE_TABLE_DATA_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const onAdd = (e) => {
    e.preventDefault();
    dispatch(
      api_request(
        API_METHOD_POST,
        "/data/RolePermissions/insert",
        {
          roleId: roleId,
          permissionId: permission.id,
          _status: ENTITY_STATUS["active"],
        },
        null,
        null,
        INSERT_TABLE_DATA_SUCCESS,
        INSERT_TABLE_DATA_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const onChange = (value, col, id) => {
    dispatch(
      api_request(
        API_METHOD_PUT,
        `/data/RolePermissions/${id}/update`,
        {
          [col]: value,
        },
        null,
        null,
        UPDATE_TABLE_DATA_SUCCESS,
        UPDATE_TABLE_DATA_ERROR,
        true,
        false,
        true,
      ),
    );
  };
  console.log("data", roleTable, rolePermissionTable);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid container>
          <Grid xs={10}>
            <CoreAutoComplete
              onChange={(id, val) => {
                setRoleId(val?.value);
              }}
              style={{ width: "100%" }}
              value={roleId}
              options={roleTable?.map((item) => {
                return {
                  value: item?.id,
                  label: item?.role,
                };
              })}
              label="Role"
            />
          </Grid>
          <Grid xs={2}>
            <CoreButtonContainer>
              <CoreButton onClick={onAdd}>Add</CoreButton>
            </CoreButtonContainer>
          </Grid>
          <CoreTypographyCaption>Added Roles : </CoreTypographyCaption>
          {permission && roleTable && rolePermissionTable && (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Action</TableCell>
                  <TableCell>Roles</TableCell>
                  <TableCell>priority</TableCell>
                  <TableCell>isVisible</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[...rolePermissionTable]
                  ?.sort((a, b) => (a?.id < b?.id ? 1 : -1))
                  ?.filter((f) => f.permissionId === permission.id)
                  ?.map((item) => (
                    <TableRow>
                      <TableCell>
                        <Tooltip title="Delete">
                          <CoreIconButton
                            size="small"
                            color="error"
                            onClick={() => {
                              onDelete(item.id);
                            }}
                          >
                            <Icon style={{ fontSize: "20px" }}>delete</Icon>
                          </CoreIconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        {roleTable?.find((f) => f.id === item?.roleId)?.role}
                      </TableCell>
                      <TableCell>
                        <CoreInput
                          type="number"
                          value={item?.priority}
                          onChange={(e) => {
                            onChange(e.target.value, "priority", item?.id);
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <CoreAutoComplete
                          style={{ width: "100%" }}
                          onChange={(id, val) => {
                            onChange(val?.value, "isVisible", item?.id);
                          }}
                          value={{
                            label: String(item?.isVisible),
                            value: item?.isVisible,
                          }}
                          options={[
                            { label: "true", value: true },
                            { label: "false", value: false },
                          ]}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          )}
        </Grid>
      </Box>
    </Modal>
  );
}
